var app = angular.module("app", []);

app.run(function ($http) {
    $(".toggle").click((e) => {
        $("body").toggleClass("navigate");
    });

    $(".uploadfaker .button").click((e) => {
        e.preventDefault();
        $(".uploadfaker input[type=file]").trigger("click");
    });

    $(".uploadfaker input[type=file]").change((e) => {
        $(".uploadfaker .input").val(e.target.files[0].name);
    });
});

app.directive("loaded", function () {
    return {
        restrict: "A",
        link: function (scope, element, attrs) {
            element.bind("load", function () {
                scope.$apply(attrs.loaded);
            });
        },
    };
});

app.service("api", function ($http) {
    const endpoint = "https://api.cappr.org/";
    const locale = document.querySelector('meta[name="locale"]').content;
    const tokens = {
        en: "NG10Z3F1UzNlQTpvbnhwRHl3SDNy",
        nl: "NW11Z3FrUzdlQTpLTHhwRHlFSDVy",
        es: "N3BwZ3FrUzdlQTpNTHhwRG1QSDdy",
        de: "N211Z3FrUzdlQTpNTHhwRHlFSDdy",
        fr: "Nm11Z3FrUzhlQTpMTHhwRHlFSDZy",
    };
    $http.defaults.headers.common.Authorization = "Basic " + tokens[locale];
    this.session = () => $http.post(endpoint + "session");
    this.question = (uid) =>
        $http.get(endpoint + "session/" + uid + "/question");
    this.answer = (uid, question, card) =>
        $http.post(endpoint + "session/" + uid + "/answer", {
            question_id: question,
            answer: card,
        });
    this.report = (uid) => $http.get(endpoint + "session/" + uid + "/report");
});

app.controller("TestController", function ($scope, $timeout, api) {
    let counter = 0;
    let start;
    let end;

    this.session;
    this.question;
    this.report;
    this.visible = [];
    this.loading = true;
    this.dragging = false;
    this.transition = false;
    this.active;
    this.started = false;

    this.start = () => {
        this.started = true;
        this.requestQuestion();
    };

    this.$onInit = () => {
        api.session().then((response) => {
            this.session = response.data;
        });
    };

    this.requestQuestion = () => {
        api.question(this.session.uid).then((response) => {
            if (response.data.done) {
                this.visible = [];
                $timeout(() => {
                    delete this.question;
                    this.requestReport();
                }, 500);
            } else {
                if (
                    !this.question ||
                    this.question.progress !== response.data.progress
                ) {
                    this.visible = [];
                }
                this.question = response.data;
            }
        });
    };

    this.requestAnswer = (card) => {
        if (!this.loading) {
            this.loading = true;
            this.visible = [card];
            api.answer(this.session.uid, this.question.id, card).then(
                (response) => {
                    this.requestQuestion();
                }
            );
        }
    };

    this.requestReport = () => {
        api.report(this.session.uid).then((response) => {
            this.report = response.data;
            $timeout(() => {
                $("form").submit();
            }, 0);
        });
    };

    this.loaded = () => {
        counter++;
        if (counter === 2) {
            this.visible = this.question.cards.map((card) => {
                return card.id;
            });
            this.active = undefined;
            this.loading = false;
            counter = 0;
        }
    };

    $(".interact .element").on("mousedown touchstart", (e) => {
        e.preventDefault();
        $timeout(() => {
            if (
                !this.loading &&
                !this.dragging &&
                (e.type === "mousedown" ||
                    (e.type === "touchstart" && e.touches.length === 1))
            ) {
                this.dragging = true;
                start = end =
                    e.type === "mousedown"
                        ? { x: e.clientX, y: e.clientY }
                        : { x: e.touches[0].clientX, y: e.touches[0].clientY };
            }
        }, 0);
    });

    $("body").on("mouseup touchend", (e) => {
        $timeout(() => {
            if (this.dragging) {
                this.dragging = false;
                this.transition = true;
                start = undefined;
                end = undefined;
                $(".interact .element").css({ transform: "translate(0, 0)" });
                $timeout(() => {
                    this.transition = false;
                }, 500);
                if (this.active !== undefined) {
                    this.requestAnswer(this.question.cards[this.active].id);
                }
            }
        }, 0);
    });

    $("body").on("mousemove touchmove", (e) => {
        $timeout(() => {
            if (
                this.dragging &&
                (e.type === "mousemove" ||
                    (e.type === "touchmove" && e.touches.length === 1))
            ) {
                end =
                    e.type === "mousemove"
                        ? { x: e.clientX, y: e.clientY }
                        : { x: e.touches[0].clientX, y: e.touches[0].clientY };
                $(".interact .element").css({
                    transform:
                        "translate(" +
                        (end.x - start.x) +
                        "px, " +
                        (end.y - start.y) +
                        "px)",
                });
                if (end.y - start.y <= -80) {
                    this.active = 0;
                } else if (end.y - start.y >= 80) {
                    this.active = 1;
                } else {
                    this.active = undefined;
                }
            }
        }, 0);
    });
});
